import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';
import * as OM from '@/messages/order';

import { useOrderDetailsContext } from '../OrderDetailsContext';

export function GiftingSection() {
  const { order } = useOrderDetailsContext();
  const isVisible = Boolean(order.isGift);

  if (!isVisible) return null;

  return (
    <Box
      backgroundColor='lightGrey'
      data-test-id='OrderDetailsViewGiftingSection'
      padding={2}
    >
      <Typography
        data-test-id='OrderDetailsViewGiftingTitle'
        fontFamily='italianPlate'
        mb={1}
        scale='h5'
        textTransform='uppercase'
      >
        {OM.Gifting}
      </Typography>
      <Typography data-test-id='OrderDetailsViewGiftFrom' fontWeight='bold'>
        {order.giftFrom}
      </Typography>
      <Typography data-test-id='OrderDetailsViewGiftMessage'>
        {order.giftMessage}
      </Typography>
    </Box>
  );
}
